module.exports = __webpack_public_path__ + "img/mob.c9f75ba8.png";